import { useState, useEffect } from "react";
import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import StepIntoSnug from "./sections/StepIntoSnug";
import TrustBarStats from "./sections/TrustBarStats";
import DrainServicesGrid from "./sections/DrainServicesGrid";
import VisibleResults from "./sections/VisibleResults";
import NossaMetodologia from "./sections/NossaMetodologia";
import FastResponseQuoteRequest from "./sections/FastResponseQuoteRequest";
import TerminalFaqAccordion from "./sections/TerminalFaqAccordion";
import RemoteSupportHelp from "./sections/RemoteSupportHelp";
import Footer from "@/reusable_sections/Footer";
function BootLoader() {
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1.2;
      });
    }, 30);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, []);
  if (!loading) return null;
  return <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black transition-opacity duration-1000">
      <div className="w-64 space-y-6 text-center">
        <div className="mx-auto flex h-20 w-20 flex-col items-center justify-center rounded-lg border-2 border-emerald-500 text-emerald-500 animate-pulse">
          <span className="text-xs font-bold leading-tight">SWAY</span>
          <span className="text-xs font-bold leading-tight">SYSTEMS</span>
        </div>
        
        <div className="space-y-2">
          <div className="h-1 w-full bg-gray-800 overflow-hidden rounded-lg">
            <div className="h-full bg-emerald-500 transition-all duration-100 ease-out" style={{
            width: `${progress}%`
          }} />
          </div>
          <p className="text-[10px] tracking-widest text-emerald-500 font-mono animate-pulse">
            INITIALIZING SWAY SYSTEMS... {Math.round(progress)}%
          </p>
        </div>
      </div>
    </div>;
}
export default function HomePage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Sway Systems",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pflugerville",
      "addressRegion": "TX",
      "addressCountry": "US"
    },
    "telephone": "(XXX) XXX-XXXX",
    "url": "https://swaysystems.com",
    "openingHours": "Mo-Fr 09:00-18:00",
    "areaServed": ["Pflugerville, TX", "Round Rock, TX", "Austin, TX"],
    "description": "Professional PC repair and IT services in Pflugerville, TX. Specializing in hardware repair, remote support, and system optimization."
  };
  useEffect(() => {
    document.title = "Sway Systems | PC Repair in Pflugerville, TX";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Sway Systems provides expert PC repair, remote support, and hardware optimization in Pflugerville, Round Rock, and Austin, TX.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = "Sway Systems provides expert PC repair, remote support, and hardware optimization in Pflugerville, Round Rock, and Austin, TX.";
      document.head.appendChild(meta);
    }
  }, []);
  return <div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />
      <BootLoader />
      <Header />
      <StepIntoSnug />
      <TrustBarStats />
      <DrainServicesGrid />
      <VisibleResults />
      <NossaMetodologia />
      <RemoteSupportHelp />
      <FastResponseQuoteRequest />
      <TerminalFaqAccordion />
      <Footer />
    </div>;
}